export default class {
  constructor(elem, data, simulation) {
    this.elem = elem;
    this.simulation = simulation;
  }
  init() {

  }
  enter() {

  }
  exit() {

  }
}



// WEBPACK FOOTER //
// ./src/d3-components/bubbles-nested-routes/ph2/layout-total.js